<button mat-button color="primary" [disabled]="!params.data.dataReceived"
    (click)="params.data.dataReceived && openLogDetailModal(params.data.dataReceived)">
    <mat-icon svgIcon="heroicons_solid:chat-bubble-left-ellipsis" [class.mat-primary]="params.data.dataReceived"></mat-icon>
</button>